import {
    PAGE_TYPE_CART,
    PAGE_TYPE_CATEGORY,
    PAGE_TYPE_CHECKOUT,
    PAGE_TYPE_HOME,
    PAGE_TYPE_PRODUCT,
    PAGE_TYPE_SUCCESS
} from 'Component/Meta/Meta.config';
import history from 'Util/History';

export const PAGES = {
    FRONT_PAGE: 'front_page',
    PDP: 'pdp',
    PLP: 'plp',
    CART: 'cart',
    CHECKOUT: 'checkout',
    PURCHASE: 'purchase'
};

/** @namespace Bodymod/Matomo/EventData/General/Data/getStoreView */
export const getStoreView = (store) => store.ConfigReducer.code || '';

/** @namespace Bodymod/Matomo/EventData/General/Data/getPath */
export const getPath = (pathname = '/', storeView = '') => {
    if (pathname.includes(storeView)) {
        return pathname.replace(`/${storeView}`, '');
    }

    return pathname;
};

/** @namespace Bodymod/Matomo/EventData/General/Data/getPageType */
export const getPageType = (pageType) => {
    switch (pageType) {
    case PAGE_TYPE_HOME:
        return { pageType: PAGES.FRONT_PAGE };
    case PAGE_TYPE_PRODUCT:
        return { pageType: PAGES.PDP };
    case PAGE_TYPE_CATEGORY:
        return { pageType: PAGES.PLP };
    case PAGE_TYPE_CART:
        return { pageType: PAGES.CART };
    case PAGE_TYPE_CHECKOUT:
        return { pageType: PAGES.CHECKOUT };
    case PAGE_TYPE_SUCCESS:
        return { pageType: PAGES.PURCHASE };
    default:
        return { pageType: '' };
    }
};

/** @namespace Bodymod/Matomo/EventData/General/Data/getTitle */
export const getTitle = (title) => ({
    title: typeof title === 'string' ? title : title?.value
});

/** @namespace Bodymod/Matomo/EventData/General/Data/getPage */
export const getPage = () => {
    const { location: { pathname, search } } = history;
    return {
        pagePath: pathname + search
    };
};

// General Event Data
/** @namespace Bodymod/Matomo/EventData/General/Data/getGeneralEventData */
export const getGeneralEventData = (data) => {
    const {
        title, type
    } = data;

    if (data) {
        return {
            ...getTitle(title),
            ...getPage(),
            ...getPageType(type)
        };
    }

    return {};
};
